import React from 'react'
import { Link } from 'react-router-dom'

import Coordenacao from './Coordenacao'
import Presidencia from './Presidencia'
import Juridico from './Juridico'
import Fiscal from './Fiscal'

export default class Processos extends React.Component {
    render() {
        // if(localStorage.tipo == 'coordenacao') {
        //     return <Coordenacao />
        // }
        // else if(localStorage.tipo == 'presidencia') {
        //     return <Presidencia />
        // }
        // else if(localStorage.tipo == 'juridico') {
        //     return <Juridico />
        // }
        // else if(localStorage.tipo == 'fiscal') {
        //     return <Fiscal />
        // }
        return (
            <div className="home">
                <Link to='/buscaProcesso'>
                    <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-search verdeUnimed icone"></i>
                        <b className="verdeUnimed">PESQUISAR PROCESSO</b>
                    </div>
                </Link>

                {/* <Link to='/novoProcesso'>
                    <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-file-alt verdeUnimed icone"></i>
                        <b className="verdeUnimed">ADICIONAR PROCESSO</b>
                    </div>
                </Link> */}
            </div>
        )
    }
}